const UtmModel = require("./event.session.utm.js");

class SessionModel {
  constructor({
    id = null,
    source = null,
    start_time = null,
    utm = new UtmModel(),
  } = {}) {
    this.id = id;
    this.source = source;
    this.start_time = start_time;
    this.utm = utm;
  }

  json() {
    return {
      id: this.id,
      source: this.source,
      start_time: this.start_time,
      utm: this.utm,
    };
  }
}

module.exports = SessionModel;
